<template>
  <div>
    <FormSectionContainer index="1" title="Adja meg az alapadatokat">
      <label for="productData.productName">Név<span class="required-star"></span></label>
      <b-form-input
        id="productData.productName"
        v-model="productData.productName"
        placeholder="Adja meg a termék nevét"
        trim
        class="mb-3"
        :state="productNameState"
        :class="`${productNameState !== null && !productNameState ? 'create-fund-error-border' : ''}`"
      ></b-form-input>
      <b-form-invalid-feedback class="create-fund-error-message" id="input-live-feedback">
        Adja meg a termék nevét
      </b-form-invalid-feedback>
      <b-row>
        <b-col cols="12" md="6" lg="6" xl="6">
          <label for="productData.productType">Termék típusa<span class="required-star"></span></label>
          <b-form-group>
            <b-form-select
              class="dropdown-form dropdown-border mb-2"
              v-model="productData.productType"
              :options="productTypeOptions"
              id="productData.productType"
              :state="productTypeState"
              :disabled="this.isEditCompetition"
              :class="`${productTypeState !== null && !productTypeState ? 'create-fund-error-border' : ''}`"
            >
              <template #first>
                <b-form-select-option id="productData.productType" :value="null" disabled>
                  Válassza ki a termék típusát
                </b-form-select-option>
              </template>
            </b-form-select>

            <b-form-invalid-feedback class="create-fund-error-message" id="input-live-feedback">
              Válassza ki a termék típusát
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="6" lg="6" xl="6">
          <label for="productData.productCode">Termék kódja</label>
          <b-form-input
            id="productData.productCode"
            v-model="productData.productCode"
            placeholder="Adja meg a termék kódját"
            trim
            class="mb-3"
          ></b-form-input>
        </b-col>
      </b-row>
      <label for="productData.productDescription">Leírás<span class="required-star"></span></label>
      <b-form-textarea
        id="productData.productDescription"
        v-model="productData.productDescription"
        placeholder="Adjon meg leírást a termékhez"
        trim
        rows="6"
        style="min-height: 150px;"
        :state="productDescriptionState"
        :class="
          `mb-3 ${productDescriptionState !== null && !productDescriptionState ? 'create-fund-error-border' : ''}`
        "
      ></b-form-textarea>

      <b-form-invalid-feedback class="create-fund-error-message" id="input-live-feedback">
        Adjon meg termékleírást
      </b-form-invalid-feedback>

      <RelatedDefinitions
        :state="productData.relatedDefinitions"
        @new-seleted-definitions="handleRelDefSelection"
      ></RelatedDefinitions>

      <label for="productData.linkToProduct">Link a termékhez<span class="required-star"></span></label>
      <b-form-input
        id="productData.linkToProduct"
        v-model="productData.linkToProduct"
        placeholder="Adja meg a termék hivatkozását a forrásgazda oldalán"
        trim
        :state="linkToProductState"
        :class="`${linkToProductState !== null && !linkToProductState ? 'create-fund-error-border' : ''}`"
      ></b-form-input>

      <b-form-invalid-feedback class="create-fund-error-message" id="input-live-feedback">
        A linknek https:// előtaggal kell kezdődnie
      </b-form-invalid-feedback>
    </FormSectionContainer>

    <FormSectionContainer
      index="2"
      title="Válasszon alkategóriákat"
      hideBackground
      required
      :key="selectedSubCategories.length > 0 ? selectedSubCategories[0] : 'selectedSubCategories'"
    >
      <div v-if="this.touched && !this.subCategoryState" class="create-fund-error-message mb-3">
        Válasszon alkategóriát.
      </div>
      <SubCategorySelector
        @new-selected-sub-categories="handleSubCatSelection"
        :subCategories="subCategories"
        :preSelection="selectedSubCategories"
      />
    </FormSectionContainer>

    <FormSectionContainer index="3" title="Megjelenés dátumának megadása">
      <div
        :class="` ${this.isDateOpen ? 'extended-date-container' : this.isTimeOpen ? 'extended-time-container' : ''}`"
        :key="appearanceDate"
      >
        <b-row class="d-flex justify-content-center component-container ">
          <DatePicker
            title="Megjelenés kezdete"
            @shown="isDatePickerOpen($event)"
            @hidden="isDatePickerOpen($event)"
            @date-value="onAppearanceStartDateSelect($event)"
            uniqueId="datepicker-1"
            :alreadySelected="this.appearanceDate.appearanceStartDate"
            :error="this.touched && !this.appearanceStartDate"
            errorMessage="Válasszon egy, a megjelenés végénél korábbi dátumot."
            required
            @which-component-is-open="handleDateComponentLayout($event)"
            :class="`${this.openDateComponent == 'datepicker-1' ? 'extended-date-layout' : ''}`"
            :key="
              this.resultDates.appearanceStartDate
                ? this.resultDates.appearanceStartDate
                : 'resultDatesAppearanceStartDate'
            "
          />

          <TimePicker
            title="Megjelenés kezdete"
            @shown="isTimePickerOpen($event)"
            @hidden="isTimePickerOpen($event)"
            @time-value="onAppearanceStartTimeSelect($event)"
            uniqueId="timepicker-1"
            :alreadySelected="this.appearanceDate.appearanceStartTime"
            @which-component-is-open="handleTimeComponentLayout($event)"
            :class="`${this.openTimeComponent == 'timepicker-1' ? 'extended-time-layout' : ''}`"
            :key="this.resultDates.appearanceStartTime"
          />
        </b-row>

        <b-row class="d-flex justify-content-center component-container ">
          <DatePicker
            title="Megjelenés vége"
            @shown="isDatePickerOpen($event)"
            @hidden="isDatePickerOpen($event)"
            @date-value="onAppearanceEndDateSelect($event)"
            uniqueId="datepicker-2"
            :alreadySelected="this.appearanceDate.appearanceEndDate"
            :error="this.touched && !this.appearanceEndDate"
            errorMessage="Válasszon egy, a megjelenés kezdeténél későbbi dátumot."
            required
            @which-component-is-open="handleDateComponentLayout($event)"
            :class="`${this.openDateComponent == 'datepicker-2' ? 'extended-date-layout' : ''}`"
            :key="
              this.resultDates.appearanceEndDate ? this.resultDates.appearanceEndDate : 'resultDatesAppearanceEndDate'
            "
          />

          <TimePicker
            title="Megjelenés vége"
            @shown="isTimePickerOpen($event)"
            @hidden="isTimePickerOpen($event)"
            @time-value="onAppearanceEndTimeSelect($event)"
            uniqueId="timepicker-2"
            :alreadySelected="this.appearanceDate.appearanceEndTime"
            @which-component-is-open="handleTimeComponentLayout($event)"
            :class="`${this.openTimeComponent == 'timepicker-2' ? 'extended-time-layout' : ''}`"
            :key="this.resultDates.appearanceEndTime"
          />
        </b-row>

        <b-row class="d-flex justify-content-center component-container ">
          <DatePicker
            title="Igénylés kezdete"
            @shown="isDatePickerOpen($event)"
            @hidden="isDatePickerOpen($event)"
            @date-value="onRequestStartDateSelect($event)"
            uniqueId="datepicker-3"
            :alreadySelected="this.appearanceDate.requestStartDate"
            :error="this.touched && !this.requestStartDate"
            errorMessage="Válasszon egy, az igénylés végénél korábbi dátumot."
            required
            @which-component-is-open="handleDateComponentLayout($event)"
            :class="`${this.openDateComponent == 'datepicker-3' ? 'extended-date-layout' : ''}`"
            :key="this.resultDates.requestStartDate ? this.resultDates.requestStartDate : 'resultDatesRequestStartDate'"
          />

          <TimePicker
            title="Igénylés kezdete"
            @shown="isTimePickerOpen($event)"
            @hidden="isTimePickerOpen($event)"
            @time-value="onRequestStartTimeSelect($event)"
            uniqueId="timepicker-3"
            :alreadySelected="this.appearanceDate.requestStartTime"
            @which-component-is-open="handleTimeComponentLayout($event)"
            :class="`${this.openTimeComponent == 'timepicker-3' ? 'extended-time-layout' : ''}`"
            :key="this.resultDates.requestStartTime"
          />
        </b-row>

        <b-row
          :class="[
            'd-flex justify-content-center component-container',
            appearanceDate.availableUntilFundIsExhausted ? 'hidden-container' : ''
          ]"
        >
          <DatePicker
            title="Igénylés vége"
            @shown="isDatePickerOpen($event)"
            @hidden="isDatePickerOpen($event)"
            @date-value="onRequestEndDateSelect($event)"
            uniqueId="datepicker-4"
            :alreadySelected="this.appearanceDate.requestEndDate"
            :error="this.touched && !this.requestEndDate"
            errorMessage="Válasszon egy, az igénylés kezdeténél későbbi dátumot."
            required
            @which-component-is-open="handleDateComponentLayout($event)"
            :class="`${this.openDateComponent == 'datepicker-4' ? 'extended-date-layout' : ''}`"
            :key="this.resultDates.requestEndDate ? this.resultDates.requestEndDate : 'resultDatesRequestEndDate'"
          />

          <TimePicker
            title="Igénylés vége"
            @shown="isTimePickerOpen($event)"
            @hidden="isTimePickerOpen($event)"
            @time-value="onRequestEndTimeSelect($event)"
            uniqueId="timepicker-4"
            :alreadySelected="this.appearanceDate.requestEndTime"
            @which-component-is-open="handleTimeComponentLayout($event)"
            :class="`${this.openTimeComponent == 'timepicker-4' ? 'extended-time-layout' : ''}`"
            :key="this.resultDates.requestEndTime"
          />
        </b-row>

        <b-row v-if="appearanceDate.availableUntilFundIsExhausted" class="d-flex component-container ">
          <b-col cols="12" md="6" lg="6" xl="6">
            <label for="availableUntilFundIsExhausted">Igénylés vége</label>
            <b-form-datepicker
              id="availableUntilFundIsExhausted"
              :show-decade-nav="false"
              :hide-header="true"
              menu-class="w-100"
              calendar-width="100%"
              :dropup="false"
              :disabled="true"
              placeholder="Keretkimerülésig"
            ></b-form-datepicker>
          </b-col>
        </b-row>

        <div class="exhaust-switch-wrapper">
          <b-form-checkbox
            v-model="appearanceDate.availableUntilFundIsExhausted"
            name="availableUntilFundIsExhausted"
            switch
          >
            <p class="until-exhaust-switch">Keretkimerülésig</p>
          </b-form-checkbox>
        </div>
      </div>
    </FormSectionContainer>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import FormSectionContainer from '../components/FormSectionContainer.vue'
import RelatedDefinitions from '../components/RelatedDefinitions.vue'
import SubCategorySelector from '../../../components/SubCategorySelector.vue'
import { getAllSubCategories } from '../../../api/fundMapCategories'
import DatePicker from '../components/DatePicker.vue'
import TimePicker from '../components/TimePicker.vue'
import * as CompetitionApi from '../../../api/competition'
export default {
  props: {
    isTouched: { type: Boolean, required: true, default: false }
  },
  data() {
    return {
      productData: {
        productName: '',
        productCode: '',
        productType: null,
        productDescription: '',
        linkToProduct: '',
        relatedDefinitions: []
      },
      selectedSubCategories: [],
      appearanceDate: {
        appearanceStartDate: '',
        appearanceStartTime: '',
        appearanceEndDate: '',
        appearanceEndTime: '',
        requestStartDate: '',
        requestStartTime: '',
        requestEndDate: '',
        requestEndTime: '',
        availableUntilFundIsExhausted: false
      },
      productTypeOptions: [
        { value: 'CREDIT', text: 'Hiteltermék' },
        { value: 'CAPITAL_PRODUCT', text: 'Tőketermék' },
        { value: 'APPLICATION', text: 'Pályázat' },
        { value: 'COMBINED', text: 'Kombinált' }
      ],
      isDateOpen: false,
      isTimeOpen: false,
      openDateComponent: '',
      openTimeComponent: '',
      subCategories: [],
      touched: this.isTouched,
      isEditCompetition: false,
      resultDates: {}
    }
  },
  computed: {
    ...mapGetters(['newFundDto']),
    productNameState() {
      if (this.touched) {
        return this.productData.productName.length > 0
      } else {
        return null
      }
    },
    productTypeState() {
      if (this.touched) {
        return this.productData.productType !== null
      } else {
        return null
      }
    },
    productDescriptionState() {
      if (this.touched) {
        return this.productData.productDescription.length > 0
      } else {
        return null
      }
    },
    linkToProductState() {
      if (this.touched) {
        return this.productData.linkToProduct.slice(0, 8) === 'https://'
      } else {
        return null
      }
    },
    subCategoryState() {
      if (this.touched) {
        return this.selectedSubCategories.length > 0
      } else {
        return null
      }
    },
    appearanceStartDate() {
      if (this.touched) {
        return (
          this.appearanceDate.appearanceStartDate.length > 0 &&
          new Date(this.appearanceDate.appearanceStartDate) < new Date(this.appearanceDate.appearanceEndDate)
        )
      } else {
        return null
      }
    },
    appearanceEndDate() {
      if (this.touched) {
        return (
          this.appearanceDate.appearanceEndDate.length > 0 &&
          new Date(this.appearanceDate.appearanceStartDate) < new Date(this.appearanceDate.appearanceEndDate)
        )
      } else {
        return null
      }
    },
    requestStartDate() {
      if (this.touched) {
        if (!this.appearanceDate.availableUntilFundIsExhausted) {
          return (
            this.appearanceDate.requestStartDate.length > 0 &&
            new Date(this.appearanceDate.requestStartDate) < new Date(this.appearanceDate.requestEndDate)
          )
        } else {
          return this.appearanceDate.requestStartDate.length > 0
        }
      } else {
        return null
      }
    },
    requestEndDate() {
      if (this.touched) {
        if (!this.appearanceDate.availableUntilFundIsExhausted) {
          return (
            this.appearanceDate.requestEndDate.length > 0 &&
            new Date(this.appearanceDate.requestStartDate) < new Date(this.appearanceDate.requestEndDate)
          )
        } else {
          return true
        }
      } else {
        return null
      }
    },
    finalResult() {
      if (
        this.productData.productName.length > 0 &&
        this.productData.productType !== null &&
        this.productData.productDescription.length > 0 &&
        this.productData.linkToProduct.slice(0, 8) === 'https://' &&
        this.selectedSubCategories.length > 0 &&
        this.appearanceDate.appearanceStartDate.length > 0 &&
        this.appearanceDate.appearanceEndDate.length > 0 &&
        this.appearanceDate.requestStartDate.length > 0 &&
        new Date(this.appearanceDate.appearanceStartDate) < new Date(this.appearanceDate.appearanceEndDate) &&
        (this.appearanceDate.availableUntilFundIsExhausted ||
          new Date(this.appearanceDate.requestStartDate) < new Date(this.appearanceDate.requestEndDate))
      ) {
        return this.$emit('is-step1-fields-filled', true)
      } else {
        return this.$emit('is-step1-fields-filled', false)
      }
    }
  },
  components: {
    FormSectionContainer,
    SubCategorySelector,
    DatePicker,
    TimePicker,
    RelatedDefinitions
  },
  methods: {
    addCompetitionAttribute(key, value) {
      this.$store.dispatch('setFundDtoPropertyAction', { [key]: value })
    },
    deleteFundType(key) {
      this.$store.dispatch('nullifyFundDtoPropertyAction', key)
    },
    handleSubCatSelection(categories) {
      this.selectedSubCategories = categories
    },
    handleRelDefSelection(slugs) {
      this.productData.relatedDefinitions = slugs[0].data
    },
    isDatePickerOpen(toggle) {
      this.isDateOpen = toggle
    },
    isTimePickerOpen(toggle) {
      this.isTimeOpen = toggle
    },
    handleDateComponentLayout(id) {
      this.openDateComponent = id
    },
    handleTimeComponentLayout(id) {
      this.openTimeComponent = id
    },
    onAppearanceStartDateSelect(date) {
      this.appearanceDate.appearanceStartDate = date
    },
    onAppearanceEndDateSelect(date) {
      this.appearanceDate.appearanceEndDate = date
    },
    onAppearanceStartTimeSelect(date) {
      this.appearanceDate.appearanceStartTime = date
    },
    onAppearanceEndTimeSelect(date) {
      this.appearanceDate.appearanceEndTime = date
    },
    onRequestStartDateSelect(date) {
      this.appearanceDate.requestStartDate = date
    },
    onRequestEndDateSelect(date) {
      this.appearanceDate.requestEndDate = date
    },
    onRequestStartTimeSelect(date) {
      this.appearanceDate.requestStartTime = date
    },
    onRequestEndTimeSelect(date) {
      this.appearanceDate.requestEndTime = date
    }
  },
  watch: {
    selectedSubCategories() {
      this.finalResult
      this.addCompetitionAttribute('selectedSubCategories', this.selectedSubCategories)
    },
    productData: {
      handler(value) {
        this.finalResult
        this.addCompetitionAttribute('productData', value)
      },
      deep: true
    },
    appearanceDate: {
      handler(value) {
        this.finalResult
        this.addCompetitionAttribute('appearanceDate', value)
      },
      deep: true
    },
    isTouched() {
      this.touched = this.isTouched
    }
  },
  async beforeMount() {
    const { competitionId } = this.$route.query
    if (competitionId) {
      this.isEditCompetition = true

      try {
        const fundResult = await CompetitionApi.getCompetitionWithDetails(competitionId)

        this.productData = fundResult.fundId.productData

        this.selectedSubCategories = fundResult.fundId.selectedSubCategories

        this.resultDates = fundResult.fundId.appearanceDate

        this.appearanceDate.appearanceStartDate = this.resultDates.appearanceStartDate.split('T')[0]
        this.appearanceDate.appearanceStartTime =
          this.resultDates.appearanceStartTime || this.resultDates.appearanceStartDate.split('T')[1].slice(0, -5)

        this.appearanceDate.appearanceEndDate = this.resultDates.appearanceEndDate.split('T')[0]
        this.appearanceDate.appearanceEndTime =
          this.resultDates.appearanceEndTime || this.resultDates.appearanceEndDate.split('T')[1].slice(0, -5)

        this.appearanceDate.requestStartDate = this.resultDates.requestStartDate.split('T')[0]
        this.appearanceDate.requestStartTime =
          this.resultDates.requestStartTime || this.resultDates.requestStartDate.split('T')[1].slice(0, -5)

        if (this.resultDates.availableUntilFundIsExhausted) {
          this.appearanceDate.availableUntilFundIsExhausted = this.resultDates.availableUntilFundIsExhausted
        } else {
          this.appearanceDate.requestEndDate = this.resultDates.requestEndDate.split('T')[0]
          this.appearanceDate.requestEndTime =
            this.resultDates.requestEndTime || this.resultDates.requestEndDate.split('T')[1].slice(0, -5)
        }
      } catch (e) {
        console.log(e)
      }
    } else {
      if (this.newFundDto.selectedSubCategories) {
        this.selectedSubCategories = this.newFundDto.selectedSubCategories
      }
      if (this.newFundDto.productData) {
        this.productData = this.newFundDto.productData
      }
      if (this.newFundDto.appearanceDate) {
        this.appearanceDate = this.newFundDto.appearanceDate
      }
    }
    try {
      const subCategories = await getAllSubCategories()
      this.subCategories = subCategories
    } catch (e) {
      this.subCategories = []
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown-border {
  border: 2px solid #b2bec3 !important;
}
.extended-date-container {
  height: 850px !important;
}
.extended-date-layout {
  margin-bottom: 550px !important;
}

.extended-time-container {
  height: 520px !important;
}

.extended-time-layout {
  margin-bottom: 250px !important;
}

@media (max-width: 767px) {
  .component-container {
    display: unset !important;
  }
  .extended-date-container {
    height: 1050px !important;
  }

  .extended-date-layout {
    margin-bottom: 450px !important;
  }

  .extended-time-container {
    height: 900px !important;
  }

  .extended-time-layout {
    margin-bottom: 250px !important;
  }
}

.create-fund-error-border {
  border: 2px solid #ba3b46 !important;
}

.create-fund-error-message {
  color: #ba3b46;
  text-align: right;
  font-size: 14px;
}
.until-exhaust-switch {
  font-size: 14px;
  font-weight: 500;
  color: #000;
}
</style>

<style lang="scss">
.exhaust-switch-wrapper {
  padding-left: 15px;
  label.custom-control-label {
    margin-top: 20px;
    padding: 2px;
    cursor: pointer;
  }
  label.custom-control-label::before {
    top: 0.25rem;
    width: 1.75rem;
    height: 1.05rem;
  }
}

.hidden-container {
  display: none !important;
}

@media screen and (min-width: 768px) {
  .exhaust-switch-wrapper {
    padding-left: 0px;
  }
}
</style>
